const hiIN= {
    login: {
      title: 'साइन इन करें',
      sign_in_btn: 'साइन इन करें'
    },
    bar: {
        logout: 'लॉग आउट करें',
        languages: 'भाषाएँ',
        settings: 'सेटिंग्स खोलें'
    },
    language: {
      name: 'अंग्रेजी (US)',
    },
    attributePage: {
        title: 'विशेषताओं में बदलाव',
        viewChanges: 'बदलावों को देखें',
        dateTime: 'दिनांक',
        notificationType: 'नोटिफ़िकेशन का प्रकार',
        notificationValue: 'नोटिफ़िकेशन का मान',
        oldValue: 'पुराना मान',
        newValue: 'नया मान',
        accept: 'स्वीकार करें',
        reject: 'अस्वीकार करें',
    },
    Home: 'होम',
    load: 'प्रारंभिक लोड चल रहा है...',
    Requested: "अनुरोधित",
    Viewed: "देखा गया",
    Executing: "निष्पादित किया जा रहा है",
    Completed: "पूरा हुआ।",
    Expired: "अवधि समाप्त हो गई है",
    Cancelled: "रद्द कर दिया गया",
    Error: "त्रुटि",
    Rejected: "अस्वीकार कर दिया गया",
    error: 'कुछ गड़बड़ी हुई; कृपया बाद में पुनः प्रयास करें।',
    displayname: 'प्रदर्शित किया जाने वाला नाम',
    givenname: 'नाम',
    surname: 'उपनाम',
    email: 'ईमेल',
    mail: 'ईमेल',
    name: 'नाम',
    firstname: 'नाम',
    lastname: 'उपनाम',
    footer_copyright: 'सर्वाधिकार सुरक्षित।'
  };
  
  export default hiIN;
  